import React from "react";
import Headers from "./Header";
import HeroSection from "./HeroSection";
import ServicesOverview from "./ServicesOverview";
import GreenCardSection from "./GreenCardSection";
import FamilySection from "./FamilySection";
import InquiryForm from "./InquiryForm";
import StatsSection from "./StatsSection";
import CitizenshipSection from "./CitizenshipSection";
import Footer from "./Footer";
import "../css/updated-new.css";

const Home = () => {
  return (
    <>
      <Headers />
      <HeroSection />
      <ServicesOverview />
      <GreenCardSection />
      <FamilySection />
      <CitizenshipSection />
      <StatsSection />
      <InquiryForm />
      <Footer />
    </>
  );
};

export default Home;
